'use client'
import React, { useState } from 'react'
import { useWalletBalanceQuery } from '@/src/queries/earnings/wallet-balance'
import { Box, Button, Flex, Image, Skeleton, Text } from '@chakra-ui/react'
import EarningAds from '../modals/earning-on-ads'
import Link from 'next/link'
import CombineMoreInfo from '../modals/combine-more-info'
import { formatLykCoinValue, formatLykCoins } from '@/lib/lyk-coin'

const EstimatedTotalBalance = () => {
  const walletBalance = useWalletBalanceQuery()

  const [isEarningAdOpen, setIsEarningAdOpen] = useState(false)
  const [isCombineMoreInfoOpen, setCombineMoreInfoOpen] = useState(false)

  const handleEarningAdOpen = () => {
    setIsEarningAdOpen(true)
  }

  const handleCombineMoreInfoOpen = () => {
    setCombineMoreInfoOpen(true)
  }

  return (
    <>
      <EarningAds
        isOpen={isEarningAdOpen}
        onClose={() => setIsEarningAdOpen(false)}
      />
      <CombineMoreInfo
        isOpen={isCombineMoreInfoOpen}
        onClose={() => setCombineMoreInfoOpen(false)}
      />

      <Box
        bg="linear-gradient(52.62deg, rgba(255, 255, 255, 0.2) 12.76%, rgba(36, 191, 163, 0.2) 110.86%)"
        boxShadow="0px 5px 9px -2px rgba(36, 191, 163, 0.40)"
        className="relative mb-2 rounded-xl bg-cover bg-no-repeat p-3 text-white sm:p-5"
      >
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Text className="text-sm font-semibold text-[#727272] sm:text-lg">
            Your estimated total balance
          </Text>
          <Flex
            color={'lyk-green'}
            className="items-center text-sm font-semibold sm:text-lg"
          >
            More info{' '}
            <Image
              boxSize={5}
              src={'/rewards/breakdown/info-green.svg'}
              alt="Icon"
              marginLeft={'4px'}
              onClick={handleCombineMoreInfoOpen}
              cursor={'pointer'}
            />
          </Flex>
        </Flex>

        <hr className="my-4 font-semibold text-[#DDDDDD]" />

        {!walletBalance.data?.unVerifiedRedeem?.lykCoin ? (
          <Flex className="w-full flex-col items-center justify-center gap-3">
            <Image
              src={'/rewards/video.svg'}
              alt="Icon"
              w={{ base: 10, sm: 12 }}
              h={{ base: 10, sm: 12 }}
              mb={1}
            />

            <Text className="px-8 text-center text-[16px] font-semibold text-[#727272] sm:text-lg">
              Either watch videos or create videos on LYKSTAGE to start earning
            </Text>

            <Button
              width={'full'}
              size={'md'}
              bg={'lyk-green'}
              color={'white'}
              as={Link}
              href={'/home'}
              _hover={{ opacity: 0.7 }}
            >
              Go to Homefeed
            </Button>
          </Flex>
        ) : (
          <>
            <Flex mb={4} mt={1} alignItems="center" gap={2.5} color="lyk-green">
              {walletBalance.isPending ? (
                <Skeleton height="50px" my={3} width="100px"></Skeleton>
              ) : (
                <>
                  <Flex
                    color="#3E3E3E"
                    className="w-full items-center justify-between gap-2"
                    fontWeight={600}
                  >
                    <Flex className="flex-col text-center text-[#797979]">
                      <Text fontSize={{ base: 20, sm: 24 }}>
                       {formatLykCoins(walletBalance.data?.unVerifiedRedeem.lykCoin) || '0'}{' '} 
                      </Text>
                      <Flex
                        alignItems={'center'}
                        justifyContent={'center'}
                        gap={1}
                      >
                        <Image
                          boxSize={{ base: 4, sm: 7 }}
                          src="/logo-color-circle.svg"
                          alt="Lykstage"
                        />
                        <Text fontSize={{ base: 18, sm: 20 }}>LYK Coins</Text>
                      </Flex>
                    </Flex>

                    <Image
                      src="/rewards/compare.svg"
                      alt="compare"
                      boxSize={{ base: 4, sm: 5 }}
                    />

                    <Flex className="flex-col text-[#797979]">
                      <Text fontSize={{ base: 20, sm: 24 }}>
                       {formatLykCoinValue(walletBalance.data?.unVerifiedRedeem.lykCoin || '0.00')}
                      </Text>
                      <Flex justifyContent={'center'}>
                        <Text fontSize={{ base: 18, sm: 20 }}>US$</Text>
                      </Flex>
                    </Flex>
                  </Flex>
                </>
              )}
            </Flex>

            <div className="hidden sm:block">
              <Text fontWeight={600} color={'#727272'} my={1} fontSize={18}>
                {/* Why are some earnings estimates? */}
                Why are some watch time earnings shown as estimates?
              </Text>
              <Text className="text-[16px] font-normal text-[#656565]">
                Wallet statement closes on the 21st of every month, which means
                one cycle is 22nd of the previous month to the 21st of
                the current month, settle on the 7th of the following month.{' '}
                <span
                  className="cursor-pointer font-semibold text-[#24BFA3] underline"
                  onClick={handleEarningAdOpen}
                >
                  Learn more here.
                </span>
              </Text>
            </div>
          </>
        )}
      </Box>

      {!walletBalance.data?.unVerifiedRedeem.lykCoin ? (
        <></>
      ) : (
        <>
          <Box className="mt-4 block rounded-2xl border-2 border-[#DDDDDD] sm:hidden">
            <div className="h-4 w-full rounded-t-2xl bg-[#24BFA3]"> </div>
            <Text
              color={'#727272'}
              fontSize={18}
              className="mt-3 px-4 py-1 font-semibold"
            >
              {/* Why are some earnings estimates? */}
              Why are some watch time earnings shown as estimates?
            </Text>
            <Text className="mb-3 px-4 text-sm font-normal text-[#656565]">
              Wallet statement closes on the 21st of every month, which means
              one cycle is 22nd of the previous month to the 21st of
              the current month, settle on the 7th of the following month.{' '}
              <span
                className="cursor-pointer font-semibold text-[#24BFA3] underline"
                onClick={handleEarningAdOpen}
              >
                Learn more here.
              </span>
            </Text>
          </Box>
        </>
      )}
    </>
  )
}

export default EstimatedTotalBalance
